<template>
  <transition name="modal" appear>
    <!-- popup (s) -->
    <div class="popWrap" id="sharePop">
      <div class="popup">
        <div class="popContain">
          <div class="popCont">
            <div class="popBody share">
              <div class="popInner">
                <!-- 본문 (s) -->
                <section class="snsArea">
                  <p class="titH3">상품공유</p>
                  <div class="snsGroup">
                    <button type="button" class="snsBtn_ka on" @click="kakaoShare">
                      <span class="blind">카카오톡</span>
                    </button>
                    <!-- 활성화 : ON -->
                    <button type="button" class="snsBtn_fb on">
                      <span class="blind">페이스북</span>
                    </button>
                    <button type="button" class="snsBtn_nv on">
                      <span class="blind">네이버</span>
                    </button>
                    <button type="button" class="snsBtn_share on">
                      <span class="blind">공유하기</span>
                    </button>
                  </div>
                </section>
                <!-- 본문 (e) -->
              </div>
            </div>

            <button type="button" class="btnIco_close" @click="$emit('close')">
              <span>팝업 닫기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- popup (e) -->
  </transition>
</template>
<script>
export default {
  name: 'sharePop',
  props: ['idx'],
  data() {
    return {
      kakaoAPI: window.Kakao,
    };
  },
  mounted() {},
  methods: {
    kakaoShare() {
      let kakaoAPI = window.Kakao;
      if (!kakaoAPI.isInitialized()) {
        kakaoAPI.init('cc01eba0f9b1c61d058c9184ba782c2a');
      }
      console.log(kakaoAPI.isInitialized());

      kakaoAPI.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: '딸기 치즈 케익',
          description: '#케익 #딸기 #삼평동 #카페 #분위기 #소개팅',
          imageUrl: '',
          link: {
            mobileWebUrl: 'https://www.welrixrental.co.kr',
            webUrl: 'https://www.welrixrental.co.kr',
          },
        },
        social: {
          likeCount: 286,
          commentCount: 45,
          sharedCount: 845,
        },
        buttons: [
          {
            title: '웹으로 보기',
            link: {
              mobileWebUrl: 'https://www.welrixrental.co.kr',
              webUrl: 'https://www.welrixrental.co.kr',
            },
          },
          {
            title: '앱으로 보기',
            link: {
              mobileWebUrl: 'https://www.welrixrental.co.kr',
              webUrl: 'https://www.welrixrental.co.kr',
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './css/popup.styl';
</style>
